import DSChip from "../../system-design/DSChip";
import { MonitorStatus } from "../../../api/admin";

interface MonitorStatusChipProps {
  status: MonitorStatus;
}

const statusColors: Record<
  MonitorStatus,
  "success" | "error" | "warning" | "default"
> = {
  [MonitorStatus.Success]: "success",
  [MonitorStatus.Failed]: "error",
  [MonitorStatus.Running]: "warning",
  [MonitorStatus.Pending]: "default",
};

const MonitorStatusChip = ({ status }: MonitorStatusChipProps) => {
  return (
    <DSChip
      label={status}
      color={statusColors[status]}
      size="small"
      sx={{ textTransform: "capitalize" }}
    />
  );
};

export default MonitorStatusChip;
